import { createElement } from "../utils/create-elem.js";
/**
 * Creates a select dropdown with options.
 * @param {Object} params - The parameters for creating the select element.
 * @param {string[]} params.classes - Optional array of CSS class names.
 * @param {HTMLElement} params.parent - Optional parent element to append the select.
 * @param {{text: string, value: string}[]} options
 * @param {number|string} [params.index] - Index of the selected option (number or string).
 * @param {Function} onClick
 * @returns {HTMLSelectElement} - The created select element.
 */
export function select(params) {
  const { parent, classes = [], options, onChange, index } = params;
  const elem = createElement({
    tag: "select",
    parent: parent,
    classes: classes,
    children: options.map((option) =>
      createElement({
        tag: "option",
        text: option.text,
        value: String(option.index),
      })
    ),
  });
  elem.addEventListener("change", onChange);

  return elem;
}
